import React, { useContext, useEffect } from "react";
import { Container } from "react-bootstrap";
import { withRouter } from "react-router-dom";
import { I18nContext } from "../../i18n";
import PersonInfo from "../common/PersonInfo";
import CorrespondenceInfo from "../common/CorrespondenceInfo";
import BasicInfo from "./KBasicInfo";
import DetailedInfo from "./KDetailedInfo";
import MobileNavbar from "../../components/header/MobileNavbar";
import ExpandedNavbar from "../../components/header/ExpandedNavbar";
import UseWindowSize from "../../customHooks/useWindowSize";
import { formatDate } from "../../helpers/helpers";
import { bootStrapGrid } from "../../constants/constants";
import PageNotFound from "../errors/PageNotFound";


const KApplication = (props) => {
  const { translate } = useContext(I18nContext);
  const size = UseWindowSize();
  document.title = translate("application_title_international") + " | PRH";

  const fields = props.data.data;

  const basicInfo = {
    applicationNumber: fields.applicationNumber,
    registrationNumber: fields.registrationNumber,
    applicationDate: formatDate(fields.applicationDate),
    registrationDate: formatDate(fields.registrationDate),
    expirationDate: formatDate(fields.expirationDate),
    dossierStatus: fields.dossierStatus,
    sentToWIPO: formatDate(fields.sentToWIPO),
  };

  const detailedInfo = {
    relatedTrademarks: fields.relatedTrademarks,
  };

  const fetchInternational = props.fetchInternational;
  let path = "";
  props.match.params.registrationNumber
    ? (path =
        "trademark/ia/" +
        props.match.params.applicationNumber +
        "/" +
        props.match.params.registrationNumber)
    : (path = "trademark/ia/" + props.match.params.applicationNumber);

  useEffect(() => {
    props.pathParams.updateLanguage();
    fetchInternational(path);
  }, []);

  if (fields.length < 1) {
    if(props.data.error)
      return (<PageNotFound title="trademark_not_found" description="trademark_not_found_description"/>);

    return null;
  }

  return (
    <div>
      <div id="skip">
        <a href="#k_content">{translate("jumplink_to_content")}</a>
      </div>
      {size.width < bootStrapGrid.md ? (
        <MobileNavbar pathParams={props.pathParams} />
      ) : (
        <ExpandedNavbar pathParams={props.pathParams} />
      )}
      <main id="k_content" tabIndex="-1">
        <Container className={"mt-4 mb-4"}>
          <BasicInfo data={basicInfo} />
          <DetailedInfo data={detailedInfo} pathParams={props.pathParams} />
          <PersonInfo
            title={translate("k_application_applicant")}
            persons={fields.applicants}
          />

          <PersonInfo
            title={translate("trademark.portlet.representative")}
            persons={fields.representatives}
          />
          <CorrespondenceInfo data={fields.correspondence} />
        </Container>
      </main>
    </div>
  );
};

export default withRouter(KApplication);
